import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axiosInstance from '../../utils/axiosConfig';
import { setUserData } from '../../redux/slices/userSlice';
import { setAdminStatus } from '../../redux/slices/isAdminSlice';
import LoaderInside from '../LoaderInside';
import './Auth.scss';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axiosInstance.post('/auth/login', {
        username,
        password,
      });

      if (response.data.success) {
        // Сохраняем токен
        localStorage.setItem('authToken', response.data.token);

        // Сохраняем данные пользователя в Redux
        const user = response.data.user;
        dispatch(setUserData({
          userId: user.id || user._id,
          telegramId: user.telegramID || null,
          username: user.username,
          accountType: user.accountType,
          isAccepted: user.isAccepted,
          isNew: user.isNew || false,
        }));

        // Устанавливаем админский статус
        dispatch(setAdminStatus(user.role === 'superuser'));

        // Полная перезагрузка страницы для обновления состояния в App.js
        window.location.href = '/';
      } else {
        setError(response.data.error || 'Ошибка входа');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка входа. Проверьте данные.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-card__ornaments" aria-hidden="true">
          <svg className="corner top-left" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M34 2H13.6364L2 12.2655V31" stroke="#E9F7FA" strokeWidth="3" strokeMiterlimit="10" />
          </svg>
          <svg className="corner top-right" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 2H36.3636L48 12.2655V31" stroke="#E9F7FA" strokeWidth="3" strokeMiterlimit="10" />
          </svg>
          <svg className="corner bottom-left" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M34 48H13.6364L2 37.7345V19" stroke="#E9F7FA" strokeWidth="3" strokeMiterlimit="10" />
          </svg>
          <svg className="corner bottom-right" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 48H36.3636L48 37.7345V19" stroke="#E9F7FA" strokeWidth="3" strokeMiterlimit="10" />
          </svg>
        </div>
        <h1 className="auth-title">Вход</h1>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label htmlFor="username">Имя пользователя</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
              placeholder="Введите имя пользователя"
            />
          </div>

          <div className="auth-field">
            <label htmlFor="password">Пароль</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="Введите пароль"
            />
          </div>

          {error && <div className="auth-error">{error}</div>}

          <button
            type="submit"
            className="auth-button"
            disabled={loading}
          >
            {loading ? <LoaderInside /> : 'Войти'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;

